const noEmptyStringValidator = async (_, value) => {
  if (!String(value ?? '').trim().length) throw new Error('Must not be an empty string');
  return true;
};

const noEmptySelectValidator = async (_, value) => {
  if (!value) throw new Error('Must not be an empty string');
  return true;
};

export { noEmptyStringValidator, noEmptySelectValidator };
